import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { WizardBackLink } from "../types";
import { WizardHeaderRow, WizardTitleBlock } from "../style";

interface WizardHeaderProps {
  title: string;
  breadcrumb?: React.ReactNode;
  backLink?: WizardBackLink;
  headerAction?: React.ReactNode;
  titleBadge?: React.ReactNode;
}

const WizardHeader: React.FC<WizardHeaderProps> = ({
  title,
  breadcrumb,
  backLink,
  headerAction,
  titleBadge,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (!backLink) return;
    if (backLink.onClick) {
      backLink.onClick();
      return;
    }
    if (backLink.to) navigate(backLink.to);
  };

  return (
    <WizardTitleBlock>
      {(breadcrumb || backLink) && (
        <WizardHeaderRow>
          <Box sx={{ minWidth: 0, flex: 1 }}>{breadcrumb}</Box>
          {backLink && (
            <Box
              onClick={handleBackClick}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                cursor: "pointer",
                color: theme.palette.primary.main,
                fontWeight: 600,
                fontSize: "14px",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              {backLink.label}
              <ExternalLink size={14} />
            </Box>
          )}
        </WizardHeaderRow>
      )}

      <WizardHeaderRow>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "28px",
              fontWeight: 700,
              color: theme.palette.text.primary,
              lineHeight: 1.2,
              minWidth: 0,
            }}
          >
            {title}
          </Typography>
          {titleBadge}
        </Box>
        {headerAction}
      </WizardHeaderRow>
    </WizardTitleBlock>
  );
};

export default WizardHeader;
